import { transformDateValue } from 'core/js/FormUtils';
export const getStockorderproductView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let stockorderproductList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
                            {"fieldLabel":"Product Id","fieldValue":transformDataValue(data.productid,"bodynamiclist"), "fieldType":"bodynamiclist"},
                            {"fieldLabel":"Product Name","fieldValue":transformDataValue(data.productname,"string"), "fieldType":"string"},
                            {"fieldLabel":"Qty","fieldValue":transformDataValue(data.qty,"number"), "fieldType":"number"},
                            {"fieldLabel":"Matter","fieldValue":transformDataValue(data.matter,"string"), "fieldType":"string"},
                            {"fieldLabel":"Delivery Priority Id","fieldValue":transformDataValue(data.deliverypriorityid,"bodynamiclist"), "fieldType":"bodynamiclist"},
                            {"fieldLabel":"Delivery Priority Name","fieldValue":transformDataValue(data.deliverypriorityname,"string"), "fieldType":"string"},
                            {"fieldLabel":"Expected Delivery","fieldValue":transformDataValue(data.expecteddelivery,"date"), "fieldType":"date"},
                            {"fieldLabel":"Printing Type","fieldValue":transformDataValue(data.printingtype,"boolean"), "fieldType":"boolean"},
                            {"fieldLabel":"Stitching Type","fieldValue":transformDataValue(data.stitchingtype,"boolean"), "fieldType":"boolean"},
                            {"fieldLabel":"With Printing","fieldValue":transformDataValue(data.withprinting,"boolean"), "fieldType":"boolean"},
                            {"fieldLabel":"Stock Order Id","fieldValue":transformDataValue(data.stockorderid,"ID"), "fieldType":"ID"},
                            {"fieldLabel":"Received Qty","fieldValue":transformDataValue(data.receivedqty,"number"), "fieldType":"number"},
                            {"fieldLabel":"Remarks","fieldValue":transformDataValue(data.remarks,"string"), "fieldType":"string"},
                            {"fieldLabel":"Stitching Worker Id","fieldValue":transformDataValue(data.stitchingworkerid,"bodynamiclist"), "fieldType":"bodynamiclist"},
                            {"fieldLabel":"Stitching Worker Name","fieldValue":transformDataValue(data.stitchingworkername,"string"), "fieldType":"string"},
                            {"fieldLabel":"Stitching Rate","fieldValue":transformDataValue(data.stitchingrate,"double"), "fieldType":"double"},
              
              
            ],
            'dataList': [
                
              ]
          }

          stockorderproductList.push(card);
  })
  return stockorderproductList;
}